import { MenuItem } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from '../../../reduxToolkit/typedRedux';
import { createLivestream } from '../../../services/services';
import VyButton from '../../common/VyButton';
import VyModal from '../../common/VyModal';
import VySelect from '../../common/VySelect';
import VyTextField from '../../common/VyTextField';
import VyUpload from '../../common/VyUpload';

interface VyUploadModalProps {
  onSubmit: () => void;
  onClose: () => void;
  open?: boolean;
  eventid?: string;
}

const LivestreamModalCreate = ({ onSubmit, open = false, onClose, eventid }: VyUploadModalProps) => {
  const { t } = useTranslation(['account']);
  const { handleSubmit, control } = useForm();

  const event = useSelector((state) => state.admin.event);

  const [thumbnail, setThumbnail] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(props: any) {
    setLoading(true);

    try {
      await createLivestream({ ...props, thumbnail, event: eventid, simulcast: props.simulcast });
      onSubmit();
    } catch (err) {
      console.error(err);
    }

    onClose();
    setLoading(false);
  }

  return (
    <>
      <VyModal disableDefaultStyling open={open} onClose={onClose} maxWidth={600} title={t('livestream.add')}>
        {() => (
          <div className="flex flex-col">
            <form onSubmit={handleSubmit(submit)} className="flex flex-col justify-between space-y-3">
              <label className="flex flex-col">
                <span>Name</span>
                <Controller
                  control={control}
                  name="name"
                  rules={{ required: true }}
                  render={({ field }) => <VyTextField {...field} color="secondary" fullWidth />}
                />
              </label>
              {event?.modules?.livestreams?.settings?.canSelectStreamProvider && (
                <label className="flex flex-col">
                  <span>Ingest</span>
                  <Controller
                    control={control}
                    defaultValue="global"
                    name="streamType"
                    render={({ field: { onChange, value } }) => (
                      <VySelect variant="outlined" value={value} placeholder="Ingest" onChange={(e) => onChange(e.target.value)} fullWidth>
                        <MenuItem value="global">Global Ingest (PRIO 1)</MenuItem>
                        <MenuItem value="europe">Europe Ingest (PRIO 2)</MenuItem>
                      </VySelect>
                    )}
                  />
                </label>
              )}

              <div className="mb-4">
                <span>Thumbnail</span>
                <VyUpload
                  randomExternalImageButton={false}
                  onChange={(fileId: string | null) => {
                    setThumbnail(fileId);
                  }}
                  recommendedAspectRatio="1920 x 1080"
                />
              </div>
              <VyButton disabled={loading} showLoadingIcon={loading} type="submit" className="self-center">
                {t('livestream.add')}
              </VyButton>
            </form>
          </div>
        )}
      </VyModal>
    </>
  );
};

export default LivestreamModalCreate;
